import { AttendanceForm } from "src/schemas/add-attendance";
import { EMPLOYEE_BASE_URL, HR_BASE_URL } from "./appConst";
import { axiosAuth } from "./common";
import { AttendanceFilters } from "src/screens/Dashboard/HR/Attendance/hooks/useFetchTodayAttendance";
import { Filters } from "src/screens/Dashboard/HR/Attendance/hooks/useAttendanceHistory";
import { Filters as LeaveFilters } from 'src/screens/Dashboard/HR/leaveManagement/hooks/useLeaves';

const DEFAULT_PAGE = 1;
const DEFAULT_PAGE_SIZE = 25;

export const getTodayAttendance = async (filters: AttendanceFilters = {}) => {
  const { name, status, page = DEFAULT_PAGE } = filters;

  const params = new URLSearchParams();
  params.set("page", page.toString());
  params.set("page_size", DEFAULT_PAGE_SIZE.toString());

  if (name?.trim()) params.set("name", name.trim());
  if (status) params.set("status", status);

  const api = axiosAuth();

  const { data } = await api.get(
    `${HR_BASE_URL}/attendance/today?${params.toString()}`,
  );

  return data.data;
};

// get the leave requests
export const getLeaveRequests = async (filter: LeaveFilters) => {

  const { page , pagesize, name} = filter;

  const params = new URLSearchParams();

  params.set("page", page.toString());
  params.set("pagesize", pagesize.toString());
  params.set("name", name ?? "");

  const api = axiosAuth(HR_BASE_URL);

  const { data } = await api.get(
    `/leaves?${params.toString()}`,
  );

  return data.data.leaves;
};

// change status of the leave request
export const changeLeaveStatus = async (
  id: string,
  status: "APPROVED" | "REJECTED",
  reason?: string,
) => {
  const api = axiosAuth(HR_BASE_URL);

  const { data } = await api.patch(`/leaves/status/${id}`, {
    status: status,
    rejection_reason: reason ?? null,
  });

  return data.data;
};

// add attendance by employee code
export const addAttendance = async (values: AttendanceForm) => {
  const api = axiosAuth(HR_BASE_URL);

  const res = await api.post(`/attendance`, {
    employee_code: values.employee_code,
    checkin_time: values.checkin_time,
    attendance_status: values.attendance_status,
    date: values.date,
  });

  return res.data;
};

// get attendance history of all employee
export const getAttendanceAll = async (filters: Filters) => {
  
  const { page, employee_code, name, date } = filters;

  const params = new URLSearchParams();

  params.set("page", page.toString());

  if (employee_code?.trim()) params.set("employee_code", employee_code.trim());
  if (name?.trim()) params.set("name", name.trim());
  if (date?.trim()) params.set("date", date.trim());
  
  const api = axiosAuth(HR_BASE_URL);

  const { data } = await api.get(`/attendance/all?pagesize=25&${params.toString()}`);

  return data.data.attendance;
};

export const getAllAttendanceHistory = async (params) => {
  const api = axiosAuth();

  const response = await api.get(`${HR_BASE_URL}/attendance/all`, {
    params: {
      page: 1,
      pagesize: 10000,
      employee_code: params.employee_code,
    },
  });

  return response.data;
};

// get attendance history by id
export const getAttendanceByID = async (id: number) => {
  const api = axiosAuth();

  const response = await api.get(
    `${HR_BASE_URL}/attendance/employee/${id}?page=1&page_size=1000`,
  );

  return response.data;
};

// get leave reuqest by employee id
export const getLeaveRequestsByID = async (id: number) => {
  const api = axiosAuth();

  const { data } = await api.get(
    `${HR_BASE_URL}/employee/leaves/${id}?page=1&pagesize=50`,
  );

  return data.data.leaves;
};

export const getMediaUploaded = async (id: string) => {
  const api = axiosAuth(HR_BASE_URL);

  const { data } = await api.get(`/media/attendance/${id}`);

  return data.data.media;
};

// add holiday
export const addHoliday = async (payload) => {
  const api = axiosAuth();

  const res = await api.post(`${HR_BASE_URL}/holiday`, {
    date: payload.date,
    month: payload.month,
    year: payload.year,
    occasion: payload.occasion,
  });

  return res.data;
};

export const deleteDwoMedia = async (id: string) => {
  const api = axiosAuth(HR_BASE_URL);

  const res = await api.delete(`/media/${id}`);

  return res.data;
};

export const updateDwoMediaStatus = async (
  id: string,
  status: "APPROVED" | "REJECTED",
) => {
  const api = axiosAuth(HR_BASE_URL);

  const res = await api.patch(`/media/approve`, {
    id,
    status,
  });

  return res.data;
};

export const deleteRwoMedia = async (id: string) => {
  const api = axiosAuth(EMPLOYEE_BASE_URL);

  const res = await api.delete(`/rwo-tracker/daily/media/${id}`);

  return res.data;
};

export const approveRwoMedia = async (
  id: string,
) => {
  const api = axiosAuth(EMPLOYEE_BASE_URL);

  const res = await api.patch(`/rwo-tracker/daily/media/${id}/approve`);

  return res.data;
};

export const rejectRwoMedia = async (
  id: string,
) => {
  const api = axiosAuth(EMPLOYEE_BASE_URL);

  const res = await api.patch(`/rwo-tracker/daily/media/${id}/reject`);

  return res.data;
};
